export const IS_DEV = process.env.NODE_ENV === 'development';

export const FORMIE_FORM_UID_PARAM =
  process.env.NEXT_PUBLIC_FORMIE_FORM_UID_PARAM || 'fuid';
export const FORMIE_FORM_SUBMISSION_UID_PARAM =
  process.env.NEXT_PUBLIC_FORMIE_FORM_SUBMISSION_UID_PARAM || 'suid';
